import { useCallback, useEffect, useState } from "react";
import { getStatus } from "../../../services/mfa/mfaSettingsApi";
import { describeMfaError } from "../../../services/mfa/mfaErrorMessages";

const MALFORMED_STATUS = "Unable to load authenticator status.";

const useAuthenticatorStatus = () => {
  const [status, setStatus] = useState(null);
  // docs/specs/sms-factor.md wire contract: `sms` is absent until node sends it; null keeps today's page.
  const [sms, setSms] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [signInRequired, setSignInRequired] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    setSignInRequired(false);
    try {
      const body = await getStatus();
      if (!body?.authenticator?.status) throw new Error(MALFORMED_STATUS);
      setStatus(body.authenticator.status);
      setSms(body.sms?.status ? body.sms : null);
    } catch (e) {
      setStatus(null);
      setSms(null);
      const detail = describeMfaError(e);
      setSignInRequired(detail.signIn);
      setError(e.message === MALFORMED_STATUS ? MALFORMED_STATUS : detail.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { status, sms, loading, error, signInRequired, refresh };
};

export default useAuthenticatorStatus;
